/* assets/ayaq-video-full-width.js — jQuery, avec normalisation URL + logs + fade */
(function ($) {
  if (!$) { console.error("[AYAQ] jQuery manquant"); return; }

  // Si le fichier est chargé après DOM ready, jQuery déclenchera quand même la fonction
  $(function () {
    var cfgMap = (window.AYAQ_VIDEO_CFG && typeof window.AYAQ_VIDEO_CFG === 'object') ? window.AYAQ_VIDEO_CFG : {};
    var all = Object.values(cfgMap || {});
    if (!all.length) { console.warn("[AYAQ] AYAQ_VIDEO_CFG vide"); return; }

    $.each(all, function (_, cfg) { initOne(cfg); });

    function initOne(cfg) {
      var sid         = cfg.sectionId;
      var $container  = $("#homevideo-video-container-" + sid);
      var $poster     = $("#homevideo-poster-" + sid);
      var $overlay    = $("#overlay-" + sid);
      var $playBtn    = $("#video-play-btn-" + sid);
      var $buttons    = $("#buttons_sounds-" + sid);

      var screenWidth = window.innerWidth;
      var videoSrc    = (screenWidth <= 750 && cfg.videoSrcMobile) ? cfg.videoSrcMobile : cfg.videoSrcDesktop;
      var soundNA     = !!cfg.soundNoAutoplay;

      if (!videoSrc || !$container.length) {
        console.warn("[AYAQ] stop: pas de videoSrc ou pas de container", sid, videoSrc, $container.length);
        return;
      }

      // --- Crée <video> ---
      var video  = document.createElement("video");
      video.id   = "videolanding-" + sid;
      video.loop = true;
      video.muted = !soundNA;
      video.autoplay = !soundNA;
      video.playsInline = true;
      video.preload = "auto";
      video.className = "homevideo-media";

      var source = document.createElement("source");
      source.src  = videoSrc;
      source.type = "video/mp4";
      video.appendChild(source);
      $container.append(video);

      $(video).on("canplay", function(){ if ($poster.length) $poster.css('display','none'); });

      // --- Contrôles si pas d’autoplay (son) ---
      if (soundNA) {
        if ($playBtn.length && $buttons.length) $playBtn.show();
        $container.on("click", function () {
          video.muted = !video.muted;
          if ($playBtn.length) $playBtn.hide();
          if (video.paused) { video.play().catch(console.error); }
          else { video.pause(); }
        });
        $playBtn.on("click", function () {
          video.play().then(function(){ $playBtn.hide(); }).catch(console.error);
        });
      }

      // --- Sous-titres (VTT/SRT) ---
      var cues = Array.isArray(cfg.cues) ? cfg.cues.slice() : [];
      var lastIdx = -1;
      var FADE_IN = 1000, FADE_OUT = 1000;

      // NE PAS faire .hide() (display:none) sinon les transitions CSS + fade sont incohérentes
      // Laisse l’overlay contrôlé par l’opacité CSS (.overlay / .overlay.show)

      // Normalise l’URL (//... -> https://...)
      var subUrl = cfg.subtitlesUrl || "";
      if (subUrl.indexOf("//") === 0) subUrl = window.location.protocol + subUrl;
      if (subUrl) {
        console.log("[AYAQ] subtitles url =", subUrl);
        loadSubtitles(subUrl).done(function (text) {
          console.log("[AYAQ] subtitles loaded, len =", (text || "").length);
          try {
            var list = (/^\s*WEBVTT/i.test(text) ? parseVTT(text) : parseSRT(text));
            console.log("[AYAQ] cues parsed =", list.length);
            if (Array.isArray(list) && list.length) {
              cues = list;
              lastIdx = -1;
              renderCue(video.currentTime || 0);
            }
          } catch (e) {
            console.warn("[AYAQ] Subtitles parse error:", e);
          }
        }).fail(function (xhr, status) {
          console.warn("[AYAQ] Subtitles load error:", status, subUrl, xhr && xhr.status);
        });
      } else {
        console.log("[AYAQ] pas de subtitlesUrl pour", sid);
      }

      // Rendu overlay (fade jQuery + \n => <br>)
      function renderCue(t) {
        if (!$overlay.length || !cues.length) return;

        var i = -1;
        for (var k = 0; k < cues.length; k++) {
          var c = cues[k];
          if (t >= c.start && t <= c.end) { i = k; break; }
        }

        if (i !== lastIdx) {
          if (i >= 0) {
            var cue = cues[i];
            var html = (cue.text || "").replace(/\n/g, "<br>");
            if (lastIdx === -1) {
              applyOverlayPos($overlay[0], cue);
              $overlay.html(html).stop(true, true).fadeIn(FADE_IN).addClass('show');
            } else {
              $overlay.stop(true, true).fadeOut(FADE_OUT, function () {
                applyOverlayPos($overlay[0], cue);
                $overlay.html(html).fadeIn(FADE_IN).addClass('show');
              });
            }
          } else {
            $overlay.stop(true, true).fadeOut(FADE_OUT, function(){ $overlay.removeClass('show'); });
          }
          lastIdx = i;
        }
      }

      $(video).on("timeupdate", function(){ renderCue(video.currentTime); });
      $(video).on("seeked",     function(){ renderCue(video.currentTime); });
      $(video).on("play",       function(){ renderCue(video.currentTime); });

      // API utilitaire
      window["showVideoText_" + sid] = function (txt, ms) {
        ms = ms || 2000;
        if (!$overlay.length) return;
        var html = (txt || "").replace(/\n/g, "<br>");
        $overlay.stop(true, true).fadeOut(150, function () {
          $overlay.html(html).fadeIn(200).addClass('show');
        });
        clearTimeout(window["showVideoText_" + sid]._t);
        window["showVideoText_" + sid] = window["showVideoText_" + sid] || {};
        window["showVideoText_" + sid]._t = setTimeout(function () { $overlay.fadeOut(200).removeClass('show'); }, ms);
      };
    }

    // -------- Helpers (jQuery) --------
    function loadSubtitles(url) {
      return $.ajax({ url: url, method: "GET", cache: false, dataType: "text" });
    }
    function parseVTT(text) {
      var body = (text || "").replace(/^\uFEFF?WEBVTT[^\n]*\n+/i, "");
      return parseTimedText(body);
    }
    function parseSRT(text) {
      var body = (text || "").replace(/^\uFEFF?/, "").replace(/\r/g, "").replace(/^\d+\n/gm, "");
      return parseTimedText(body);
    }
    function parseTimedText(body) {
      var lines = (body || "").split("\n");
      var out = [], start=null, end=null, buf=[];
      var timeRe = /(\d{2}:\d{2}:\d{2}[.,]\d{1,3})\s*-->\s*(\d{2}:\d{2}:\d{2}[.,]\d{1,3})/;
      function flush(){ if (start!=null && end!=null){ out.push({ start:start, end:end, text:buf.join("\n").trim() }); } start=end=null; buf.length=0; }
      for (var i=0;i<lines.length;i++){
        var line = lines[i], m = line.match(timeRe);
        if (m){ flush(); start = toSec(m[1]); end = toSec(m[2]); }
        else if ($.trim(line)===""){ flush(); }
        else { buf.push(line); }
      }
      flush();
      return out;
    }
    function toSec(ts) {
      var s = (ts || "").replace(",", ".");
      var parts = s.split(":");
      return (+parts[0])*3600 + (+parts[1])*60 + parseFloat(parts[2] || "0");
    }
    function applyOverlayPos(el, cue) {
      var set = function (k, v) { el.style.setProperty(k, v); };
      var clear = function () {
        for (var i=0;i<arguments.length;i++){ el.style.removeProperty(arguments[i]); }
      };
      clear('--ov-top','--ov-right','--ov-bottom','--ov-left','--ov-transform','--ov-width','--ov-align',
            '--ov-bg','--ov-size','--ov-color','--ov-pad','--ov-radius');

      var preset = (cue.pos || '').toLowerCase();
      var presets = {
        'bottom-center': function(){ set('--ov-top','auto'); set('--ov-bottom','8%'); set('--ov-left','0'); set('--ov-right','0'); set('--ov-transform','none'); set('--ov-align','center'); set('--ov-width','100%'); },
        'top-center':    function(){ set('--ov-top','8%'); set('--ov-bottom','auto'); set('--ov-left','0'); set('--ov-right','0'); set('--ov-transform','none'); set('--ov-align','center'); set('--ov-width','100%'); },
        'center':        function(){ set('--ov-top','50%'); set('--ov-left','50%'); set('--ov-right','auto'); set('--ov-bottom','auto'); set('--ov-transform','translate(-50%, -50%)'); set('--ov-align','center'); set('--ov-width','auto'); },
        'top-left':      function(){ set('--ov-top','8%'); set('--ov-left','6%'); set('--ov-right','auto'); set('--ov-bottom','auto'); set('--ov-transform','none'); set('--ov-align','left'); set('--ov-width','auto'); },
        'top-right':     function(){ set('--ov-top','8%'); set('--ov-right','6%'); set('--ov-left','auto'); set('--ov-bottom','auto'); set('--ov-transform','none'); set('--ov-align','right'); set('--ov-width','auto'); },
        'bottom-left':   function(){ set('--ov-bottom','8%'); set('--ov-left','6%'); set('--ov-right','auto'); set('--ov-top','auto'); set('--ov-transform','none'); set('--ov-align','left'); set('--ov-width','auto'); },
        'bottom-right':  function(){ set('--ov-bottom','8%'); set('--ov-right','6%'); set('--ov-left','auto'); set('--ov-top','auto'); set('--ov-transform','none'); set('--ov-align','right'); set('--ov-width','auto'); }
      };
      if (presets[preset]) presets[preset]();

      if (cue.xy && (cue.xy.x || cue.xy.y)) {
        var x = (cue.xy.x != null) ? cue.xy.x : '50%';
        var y = (cue.xy.y != null) ? cue.xy.y : '50%';
        set('--ov-left', x);
        set('--ov-top', y);
        set('--ov-right', 'auto'); set('--ov-bottom','auto');
        var anchor = (cue.xy.anchor || 'left').toLowerCase();
        var tr = (anchor === 'center') ? 'translate(-50%,-50%)'
              : (anchor === 'right')  ? 'translate(-100%,-50%)'
                                      : 'translate(0,-50%)';
        set('--ov-transform', tr);
        if (!cue.style || !cue.style.width) set('--ov-width','auto');
        if (!cue.style || !cue.style.align) set('--ov-align','left');
      }

      var st = cue.style || {};
      if (st.size)   set('--ov-size', st.size);
      if (st.bg)     set('--ov-bg', st.bg);
      if (st.color)  set('--ov-color', st.color);
      if (st.pad)    set('--ov-pad', st.pad);
      if (st.radius) set('--ov-radius', st.radius);
      if (st.align)  set('--ov-align', st.align);
      if (st.width)  set('--ov-width', st.width);
    }
  });
})(window.jQuery);
